import { requestFromServer } from './api-client';

const TransporterClient = {
  getRelationByCNPJ: async (cnpj, idUser, type) => {
    return requestFromServer(
      `v1/Transporters/getRelationByCNPJ/${idUser}/${type}?document_number=${cnpj}`
    );
  },
  getRelationByAddress: async (address, idUser, type) => {
    return requestFromServer(
      `v1/Transporters/getRelationByAddress/${address}/${idUser}/${type}`
    );
  },
  getUserTransporters: async (id) => {
    return requestFromServer(`v1/Transporters/getUserTransporters`);
  },
  getTranporterByCNPJ: (cnpj) => {
    return requestFromServer(`v1/Transporters/getByCNPJ?cnpj=${cnpj}`);
  },
  getTransportersByNickname: (nickname) => {
    return requestFromServer(`v1/Transporters/getByNickname/${nickname}`);
  },
  getTransportersByDocument: (document) => {
    return requestFromServer("v1/Transporters/searchByDocument", "POST", { document });
  }
};

export default TransporterClient;
